import {
  Button,
  createTableColumn,
  TableCellLayout,
  TableColumnDefinition,
  Theme,
  Tooltip,
} from "@fluentui/react-components";
import {
  Edit20Regular,
  Delete20Regular,
  Tag20Regular,
  TagMultiple20Regular,
} from "@fluentui/react-icons";
import { formatDate } from "../../../utils/HelperFunctions";
import { KS_customerservice_Service_Clients_Connect_AdminTenantDto as ConnectSubscriptionDataDTO } from "../../../CustomerSvcService";

export const tableColsSizes = {
  customerName: {
    minWidth: 120,
    defaultWidth: 250,
  },
  customerId: {
    minWidth: 120,
    defaultWidth: 250,
  },
  registrationDate: {
    minWidth: 120,
    defaultWidth: 250,
  },
  subscription: {
    minWidth: 120,
    defaultWidth: 250,
  },
  subscriptionExpirationDate: {
    minWidth: 120,
    defaultWidth: 250,
  },
  OCRlimit: {
    minWidth: 120,
    defaultWidth: 250,
  },
  storageSize: {
    minWidth: 120,
    defaultWidth: 250,
  },
};

const styles = `
  .table__control-buttons_container {
    display: flex; flex-direction: row; width: 100%;
    justify-content: space-between; justify-items: center;
  }
  button {
    all: unset;
    appearance: none;
    border: none;
    background: none;
    box-shadow: none;
    margin: 0;
    padding: 0;
    font: inherit;
    color: inherit;
    line-height: normal;
    cursor: pointer;
    font-size: 16px;
  }
  .table__control-buttons_row {
    display: flex; 
    flex-direction: row;
    gap: 4px;
  }
`;

const ControlButtons = () => {
  return <div className="table__control-buttons_row"> - </div>;
};

export const getColumnsForSubscriptionData = (theme: Theme) =>
  [
    createTableColumn<ConnectSubscriptionDataDTO>({
      columnId: "customerName",
      renderHeaderCell: () => "Ügyfél neve",
      renderCell: (subscription: ConnectSubscriptionDataDTO) => {
        return (
          <TableCellLayout truncate>{subscription.name ?? ""}</TableCellLayout>
        );
      },
    } as TableColumnDefinition<ConnectSubscriptionDataDTO>),
    createTableColumn<ConnectSubscriptionDataDTO>({
      columnId: "customerId",
      renderHeaderCell: () => "Ügyfélazonosító",
      renderCell: (subscription: ConnectSubscriptionDataDTO) => {
        return (
          <TableCellLayout truncate>{subscription.id ?? ""}</TableCellLayout>
        );
      },
    } as TableColumnDefinition<ConnectSubscriptionDataDTO>),
    createTableColumn<ConnectSubscriptionDataDTO>({
      columnId: "registrationDate",
      renderHeaderCell: () => "Regisztráció időpontja",
      renderCell: (subscription: ConnectSubscriptionDataDTO) => {
        return (
          <TableCellLayout truncate>
            {formatDate(subscription.createdAt) ?? ""}
          </TableCellLayout>
        );
      },
    } as TableColumnDefinition<ConnectSubscriptionDataDTO>),
    createTableColumn<ConnectSubscriptionDataDTO>({
      columnId: "subscription",
      renderHeaderCell: () => "Előfizetése",
      renderCell: (subscription: ConnectSubscriptionDataDTO) => {
        return (
          <TableCellLayout truncate>
            {subscription.mainPlan ?? ""}
          </TableCellLayout>
        );
      },
    } as TableColumnDefinition<ConnectSubscriptionDataDTO>),
    createTableColumn<ConnectSubscriptionDataDTO>({
      columnId: "subscriptionExpirationDate",
      renderHeaderCell: () => "Előfizetés lejárati dátuma",
      renderCell: (subscription: ConnectSubscriptionDataDTO) => {
        return (
          <TableCellLayout truncate>
            {formatDate(subscription.expiresAt) ?? ""}
          </TableCellLayout>
        );
      },
    } as TableColumnDefinition<ConnectSubscriptionDataDTO>),
    createTableColumn<ConnectSubscriptionDataDTO>({
      columnId: "OCRlimit",
      renderHeaderCell: () => "OCR keret",
      renderCell: (subscription: ConnectSubscriptionDataDTO) => {
        return (
          <TableCellLayout truncate>
            {subscription.ocR_Credit ?? "0"}
          </TableCellLayout>
        );
      },
    } as TableColumnDefinition<ConnectSubscriptionDataDTO>),

    createTableColumn<ConnectSubscriptionDataDTO>({
      columnId: "storageSize",
      renderHeaderCell: () => "Tárhely mérete",
      renderCell: (subscription: ConnectSubscriptionDataDTO) => {
        return (
          <>
            <style>{styles}</style>
            <TableCellLayout truncate>
              <div className="table__control-buttons_container">
                {subscription.storage_Capacity ?? ""}
                {/* {ControlButtons()} */}
              </div>
            </TableCellLayout>
          </>
        );
      },
    } as TableColumnDefinition<ConnectSubscriptionDataDTO>),
  ] as TableColumnDefinition<ConnectSubscriptionDataDTO>[];
